import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import CustomTable from '@shared/components/olympics/common/customTable'
import MyImage from '@shared/components/myImage'
import { getImgURL } from '@shared-submodule/utils'
import CustomLink from '@shared/components/customLink'
import wplIcon from '@assets/images/wpl/wplLogo.svg'
import wplTitle from '@assets/images/wpl/ptTitle.png'

export default function WPLTable({ points, isMobile = false }) {
  const generateBody = (group) => {
    return points
      ?.map((ele, index) => {
        return [
          <div key={index} className="d-flex">
            <div className={styles.title}>
              <MyImage src={getImgURL(ele?.oTeam?.oImg?.sUrl)} height={24} width={24} />
            </div>
            {!isMobile ? (
              <CustomLink href={`/${ele?.oTeam?.oSeo?.sSlug}`}>
                <a>
                  <span className={styles.team}>{ele?.oTeam?.sAbbr}</span>
                </a>
              </CustomLink>
            ) : (
              <span className={styles.team}>{ele?.oTeam?.sAbbr}</span>
            )}
          </div>,
          ele?.nPlayed || 0,
          ele?.nWin || 0,
          ele?.nLoss || 0,
          ele?.nNetrr || 0,
          ele?.nPoints || 0,
          ele?.nNR || 0
        ]
      })
  }

  const bodyData = generateBody()

  const tableData2 = {
    header: ['Team', 'M', 'W', 'L', 'NRR', 'PTS', 'NR'],
    body: bodyData
  }

  return (
    <>
      <div className={styles.leaguePointsTable}>
        <div className={`d-flex flex-row justify-content-start align-items-center px-3 gap-2 ${styles.tableBanner}`}>
        <div className="d-flex gap-2 align-items-center">
          <MyImage className={styles.logo} src={wplIcon} />
          <MyImage className={styles.logo} src={wplTitle} />
        </div>
        </div>
        <CustomTable
          table={tableData2}
          noData={points?.length <= 0}
          smallTable
          isChess
        />
      </div>
    </>
  )
}

WPLTable.propTypes = {
  points: PropTypes.array,
  isMobile: PropTypes.bool
}
